<template>
    <div>
        <div class="bg-white shadow-lg pt-2 pb-3 mb-3" style="border-radius: 20px">
            <div class="d-flex align-items-center">
                <div class="px-4 d-flex align-items-center ml-auto">
                    <div class="p-2 ml-auto">{{ $t('transaction_routing.charts.transactions_rate')}}</div>
                </div>
            </div>
            <hr />
            <div id="transactions-rate-chart"></div>
        </div>
    </div>
</template>
<script>
    import ApexCharts from "apexcharts";
    import {totalOptions, pspLabelVariant} from "../../../constants/ApexChartOptions"
    import { i18n } from '@/plugins/i18n'

    export default {
        name: "transactions-rate-chart",
        props: ["chart_data"],
        methods: {
            fillOptions() {
                totalOptions.colors = this.fillColors()
                totalOptions.series = this.fillSeries()
                try {
                    totalOptions.yaxis.title.text = ''
                } catch (e) {
                    totalOptions.yaxis[0].title.text = ''
                }
                totalOptions.xaxis.categories = this.fillDateAxis()
            },
            fillSeries() {
                let data = []
                let rate_axis = this.chart_data.rate_axis
                Object.keys(rate_axis).forEach(function (psp) {
                    let object = {
                        name: i18n.t('psp_list.' + psp),
                        data: rate_axis[psp],
                    }
                    data.push(object)
                })
                return data
            },
            fillColors() {
                let data = []
                let rate_axis = this.chart_data.rate_axis
                Object.keys(rate_axis).forEach(function (psp) {
                    data.push(pspLabelVariant.get(psp))
                })
                return data
            },
            fillDateAxis() {
                let data = []
                let date_axis = this.chart_data.date_axis
                Object.keys(date_axis).forEach(function (item) {
                    data.push(date_axis[item])
                })
                return data
            }
        },
        mounted() {
            this.fillOptions()
            let chart = new ApexCharts(document.querySelector("#transactions-rate-chart"), totalOptions);
            chart.render();
        },
    };
</script>

<style>
    #chart {
        margin: auto;
    }
    .apexcharts-tooltip-text {
        text-align: right!important;
        width: 100%;
    }
    .apexcharts-tooltip-marker {
        margin-right: 1px !important;
        margin-left: 3px !important;
    }
    .apexcharts-tooltip-series-group {
        padding-right: 0 !important;
    }
    .apexcharts-tooltip-y-group {
        text-align: right!important;
        display: flex;
        justify-content: space-between;
    }
</style>